import { SharedElement } from 'components';
import {
    ErrorWrapper,
    RecoveryBoxWrapper,
    TitleWrapper,
} from 'components/account-recovery';
import * as S from 'components/account-recovery/RecoveryStep.style';
import { ActionButtons, BlurBox, Input, Logo } from 'components/ui';
import { useVerifyCode } from 'hooks/recovery';
import { useTranslation } from 'react-i18next';

export function StepVerifyCode() {
    const { t } = useTranslation();

    const {
        onSubmit,
        onInputCodeChange,
        cancelStep,
        recoveryError,
        selectedMethod,
    } = useVerifyCode();

    const reset_method = selectedMethod
        ? t(`recovery.method_${selectedMethod}`)
        : '';

    return (
        <SharedElement id="recovery-box">
            <BlurBox>
                <RecoveryBoxWrapper>
                    <SharedElement id="recovery-logo" zIndex={2} scale>
                        <Logo />
                    </SharedElement>
                    <TitleWrapper
                        error={recoveryError}
                        title={t('recovery.step_verify_code', { reset_method })}
                    />
                    <S.ContentWrapper>
                        <ErrorWrapper error={recoveryError} />
                        <S.InputsWrapper>
                            <Input
                                focusOnMount
                                name="code"
                                placeholder={t('recovery.code_placeholder')}
                                onChange={(e) =>
                                    onInputCodeChange(e.target.value)
                                }
                            />
                        </S.InputsWrapper>
                    </S.ContentWrapper>
                    <ActionButtons
                        buttons={[
                            {
                                type: 'primary',
                                text: t('buttons.ok'),
                                callback: onSubmit,
                            },
                            {
                                type: 'regular',
                                text: t('buttons.cancel'),
                                callback: cancelStep,
                            },
                        ]}
                    />
                </RecoveryBoxWrapper>
            </BlurBox>
        </SharedElement>
    );
}
